import React from 'react';
import PropTypes from 'prop-types';
import formatPrice from '../../../helpers/stringFormatters';
import CurrentPrice from './CurrentPrice';
import ReducedPrice from './ReducedPrice';
import VerticalSpacer from '../../VerticalSpacer/VerticalSpacer';
import ApproximatedConvertedPrice from './ApproximatedConvertedPrice';

const PricesComponent = props => {
  const {
    currencySymbol,
    currentPrice,
    originalPrice,
    reductionPercentage,
    approximatedConvertedPrice,
    customerCurrencySymbol,
    showSale = false
  } = props;
  return (
    <React.Fragment>
      <ReducedPrice
        formatterPriceAfterReduction={formatPrice(originalPrice, currencySymbol)}
        reductionPercentage={reductionPercentage}
        showSale={showSale}
      />
      {reductionPercentage !== 0 && <VerticalSpacer height={'5px'} />}
      <CurrentPrice formattedCurrentPrice={formatPrice(currentPrice, currencySymbol)} />
      {approximatedConvertedPrice && <VerticalSpacer height={'5px'} />}
      {approximatedConvertedPrice && (
        <ApproximatedConvertedPrice formattedPrice={formatPrice(approximatedConvertedPrice, customerCurrencySymbol)} />
      )}
    </React.Fragment>
  );
};

PricesComponent.defaultProps = {
  approximatedConvertedPrice: null,
  customerCurrencySymbol: null,
  originalPrice: null
};

PricesComponent.propTypes = {
  approximatedConvertedPrice: PropTypes.string,
  currencySymbol: PropTypes.string.isRequired,
  customerCurrencySymbol: PropTypes.string,
  currentPrice: PropTypes.string.isRequired,
  originalPrice: PropTypes.string,
  reductionPercentage: PropTypes.number,
  showSale: PropTypes.bool
};

export default PricesComponent;
